var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app control-section sidebar-menu"},[(_vm.token)?_c('Header'):_vm._e(),(_vm.token)?_c('Navigation'):_vm._e(),_c('div',{staticClass:"main-content e-sidebar-context",attrs:{"id":"maintext"}},[_c('div',{staticClass:"main"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }